import React, { FC } from "react";
import { useModal } from "src/hooks/useModal";
import { AuthPopups } from "./AuthPopups";
import { MobMenuItem } from "./MobMenuItem";
import { IMenuItem } from "./types";

interface Props {
  items: IMenuItem[];
}

export const MobMenu: FC<Props> = ({ items = [] }) => {
  const loginModal = useModal(false);
  const passwordResetModal = useModal(false);
  const passwordUpdateModal = useModal(false);
  const passwordUpdatedModal = useModal(false);

  if (!items.length) return null;

  return (
    <>
      <nav>
        <menu className="flex justify-between gap-1">
          {items.map((item) => (
            <MobMenuItem key={item.id} {...item} loginModal={loginModal} />
          ))}
        </menu>
      </nav>
      <AuthPopups
        loginModal={loginModal}
        passwordResetModal={passwordResetModal}
        passwordUpdateModal={passwordUpdateModal}
        passwordUpdatedModal={passwordUpdatedModal}
      />
    </>
  );
};
